import { render, staticRenderFns } from "./newsClassification.vue?vue&type=template&id=320abc58&scoped=true&"
import script from "./newsClassification.vue?vue&type=script&lang=js&"
export * from "./newsClassification.vue?vue&type=script&lang=js&"
import style0 from "./newsClassification.vue?vue&type=style&index=0&id=320abc58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320abc58",
  null
  
)

export default component.exports